import React from 'react';
import "./AboutPage.css";
import aboutImage from './homeimage.jpg'; // Update with the correct path to your image file
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <section id="about" className="about m-5">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          {/* Content Section */}
          <div className="col-md-6 d-flex align-items-center">
            <div style={{ textAlign: "left" }}>
              <h3>About Umami</h3>
              <p>
                  <strong>Umami, </strong>recognized as the fifth basic taste, is primarily induced by specific amino acids and nucleotides, such as L-glutamate and inosinate, which interact with specialized taste receptors. UmamiPredict uses a machine learning model for classifying peptides and small molecules as umami or non-umami. We curated a balanced dataset of 868 compounds—439 umami and 429 non-umami. Ensemble machine learning models, including LightGBM, XGBoost, and ExtraTrees, demonstrated high predictive accuracy across different datasets.
                </p>
                <p>
                  Notably, the Random Forest classifier achieved an accuracy of 92.13% on the peptide-only dataset, while Linear Discriminant Analysis and ExtraTrees classifiers attained an accuracy of 98.84% on the small molecules dataset. On the combined dataset, LightGBM achieved the highest accuracy of 96.55%, highlighting the effectiveness of integrating peptide and small molecule data for umami prediction. A user-friendly web server, UmamiPredict, will facilitate users in predicting the umami taste of molecules and peptides given SMILES as input.                </p>
            </div>
          </div>

          {/* Image Section */}
          <div className="col-md-6 d-flex align-items-center justify-content-center">
            <img 
              src={aboutImage} 
              alt="About Umami" 
              className="img-fluid" 
              style={{
                maxHeight: "500px",
                width: "auto",
                objectFit: "contain",
                borderRadius: "10px",
              }} 
            />
          </div>
        </div>

        {/* Icon Links Section */}


        <div className="row no-gutters mt-5 justify-content-center">
  <div className="col-md-4 col-sm-6 col-12 d-flex align-items-stretch mb-4">
    <Link to="/umami-predictor" className="custom-link-box">
      <h4>Predict</h4>
      <p>Section for predicting sweetness value.</p>
    </Link>
  </div>
  <div className="col-md-4 col-sm-6 col-12 d-flex align-items-stretch mb-4">
    <Link to="/how-to-use" className="custom-link-box">
      <h4>How to Use</h4>
      <p>Section explaining our methodology.</p>
    </Link>
  </div>
  <div className="col-md-4 col-sm-6 col-12 d-flex align-items-stretch mb-4">
    <Link to="/about" className="custom-link-box">
      <h4>UmamiDB</h4>
      <p>Dataset of small molecules relevant to umami taste.</p>
    </Link>
  </div>
</div>

      </div>
    </section>
  );
};

export default About;